import React, {useState} from 'react';
import {Grid, Modal} from '~/components';
import {sorters} from '~/util';
import {MdClose, MdDelete, MdFileDownload} from 'react-icons/md';
import {AiOutlineLoading3Quarters} from 'react-icons/ai';
import {usePolicySearchRequest} from './context';
import {document as doc, policySearchRequest} from '~/api';

const {DocumentTypeNames} = doc;

const PolicyAttachmentsModal = ({isOpen}) => {
    const {hideAttachmentsModal, setAttachments} = usePolicySearchRequest();

    const handleClose = () => {
        setAttachments([]);
        hideAttachmentsModal();
    };

    return (
        <Modal isModalOpen={isOpen} preventScroll className='rounded-md bg-white w-3/4'>
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className="font-semibold">Attachments</p>
                    <button
                        className="py-2 rounded-full"
                        onClick={() => handleClose()}
                    >
                        <MdClose size="1em"/>
                    </button>
                </header>
                <div className='flex flex-col items-center justify-center flex-1 p-6'>
                    <DocumentGrid/>
                </div>
            </section>
        </Modal>
    );
};

export default PolicyAttachmentsModal;

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 text-sm border-b'
};

const columns = [
    {
        title: 'File Name',
        field: 'name',
        headerClassName,
        props
    },
    {
        title: 'Type',
        cell: DocType,
        sorter: (a, b) => {
            return sorters.sortStrings(
                DocumentTypeNames[a.typeId],
                DocumentTypeNames[b.typeId]
            );
        },
        headerClassName,
        props
    },
    {
        title: '',
        key: 'download',
        canSort: false,
        cell: DownloadButton,
        headerClassName,
        props: {
            className: 'text-sm border-b hover:bg-primary-10'
        }
    },
    {
        title: '',
        key: 'delete',
        canSort: false,
        cell: DeleteButton,
        headerClassName,
        props: {
            className: 'text-sm border-b hover:bg-primary-10'
        }
    }
];

function DocumentGrid() {
    const {attachments} = usePolicySearchRequest();

    return (
        <Grid
            className='w-3/4 text-sm text-neutral-90 mb-2'
            data={attachments}
            columns={columns}
            usePagination={false}
        />
    );
}


function DocType({data}) {
    const {typeId} = data;

    let name = DocumentTypeNames[typeId];

    if (name == undefined)
        name = '';

    return <>{name}</>;
}

function DownloadButton({data}) {

    const [downloading, setDownloading] = useState(false);

    return <>
        {downloading ? <AiOutlineLoading3Quarters className='text-blue-70 animate-spin flex items-center justify-center w-full focus:outline-none' size='1rem'/> :
            <button
                className='flex items-center justify-center w-full focus:outline-none'
                onClick={() => doc.download(data, setDownloading)}
            >
                <MdFileDownload size='1.25rem'/>
            </button>
        }
    </>;
}

function DeleteButton({data}) {
    const {fetchAll, attachments, setAttachments} = usePolicySearchRequest();
    const [deleting, setDeleting] = useState(false);
    return <>
        {deleting ? <AiOutlineLoading3Quarters className='text-blue-70 animate-spin flex items-center justify-center w-full focus:outline-none' size='1rem'/> :
            <button
                className='flex items-center justify-center w-full focus:outline-none'
                onClick={async () => {
                    if (window.confirm('Are you sure you wish to delete this document?')) {
                        try {
                            setDeleting(true);
                            await policySearchRequest.deletePolicySearchAttachment(data.id);
                            setAttachments(attachments.filter(x => x.id !== data.id));
                            await fetchAll();
                        } catch (err) {
                            alert("Unable to delete document. Error: " + JSON.stringify(err));
                        } finally {
                            setDeleting(false);
                        }
                    }
                }}
            >
                <MdDelete size='1.25rem'/>
            </button>
        }
    </>;
}
